import { CamerasForm } from './cameras';
import { AccessControlsForm } from './accessControls';
import { AxisNvrForm } from './axisNvr';
import { AlarmsForm } from './alarms';
import { EmergencyGpsForm } from './emergencyGps';
import { EarthquakesForm } from './earthquakes';
import { GatesForm } from './gates';
import { GenetecForm } from './genetec';
import { GpsForm } from './gps';
import { LprForm } from './lpr';
import { ManualDataEntryForm } from './manualDataEntry';
import { PortalsForm } from './portals';
import { PadlocksForm } from './padlocks';
import { PumpsForm } from './pumps';
import { RadarForm } from './radar';
import { RoutersForm } from './routers';
import { S2NodeForm } from './s2Node';
import { RcuForm } from './rcu';
import { SensorsForm } from './sensors';
import { ShutoffForm } from './shutoff';
import { StrobeSirenForm } from './strobeSiren';
import { SpeakersForm } from './speakers';
import { TanksForm } from './tanks';
import { ThermalTanksForm } from './thermalTanks';
import { TicketingSwdForm } from './ticketingSwd';
import { ToptechForm } from './toptech';
import { TotalFlowMetersForm } from './totalFlowMeters';
import { TripwiresForm } from './tripwires';
export const equipment = {
    get cameras() {
        return new CamerasForm();
    },
    get accessControls() {
        return new AccessControlsForm();
    },
    get axisNvr() {
        return new AxisNvrForm();
    },
    get emergencyGps() {
        return new EmergencyGpsForm();
    },
    get alarms() {
        return new AlarmsForm();
    },
    get earthquakes() {
        return new EarthquakesForm();
    },
    get gates() {
        return new GatesForm();
    },
    get genetec() {
        return new GenetecForm();
    },
    get gps() {
        return new GpsForm();
    },
    get lpr() {
        return new LprForm();
    },
    get manualDataEntry() {
        return new ManualDataEntryForm();
    },
    get portals() {
        return new PortalsForm();
    },
    get padlocks() {
        return new PadlocksForm();
    },
    get pumps() {
        return new PumpsForm();
    },
    get radar() {
        return new RadarForm();
    },
    get routers() {
        return new RoutersForm();
    },
    get s2Node() {
        return new S2NodeForm();
    },
    get rcu() {
        return new RcuForm();
    },
    get sensors() {
        return new SensorsForm();
    },
    get shutoff() {
        return new ShutoffForm();
    },
    get strobeSiren() {
        return new StrobeSirenForm();
    },
    get speakers() {
        return new SpeakersForm();
    },
    get tanks() {
        return new TanksForm();
    },
    get thermalTanks() {
        return new ThermalTanksForm();
    },
    get ticketingSwd() {
        return new TicketingSwdForm();
    },
    get toptech() {
        return new ToptechForm();
    },
    get totalFlowMeters() {
        return new TotalFlowMetersForm();
    },
    get tripwires() {
        return new TripwiresForm();
    }
};
